<div class="multiple-auth-detail">
  <div class="multiple-auth-detail__content">
    <!-- Use the shared auth form fields component with double column layout -->
    <auth-form-fields
      [authenticator]="selectedAuthenticator"
      [selectedMultipleAuthenticator]="selectedMultipleAuthenticator"
      [metadata]="metadata"
      [showDisplayName]="true"
      [enableNewTabAuthentication]="enableNewTabAuthentication"
      [disabled]="false"
      [layout]="'double'"
      (typeChange)="onSelectedTypeChange($event)"
      (subtypeChange)="onSelectedSubtypeChange($event)"
      (flowChange)="onSelectedFlowChange($event)">
    </auth-form-fields>

    <div class="multiple-auth-detail__domain">
      <bzg-button-icon 
        icon="icon-plus" 
        [filled]="true" 
        class="bz-space--inline-s"
        [disabled]="showInputForNewDomain || editModeDomain || isActiveMaintenance"
        (click)="onAddDomain()">
      </bzg-button-icon>
      <div class="multiple-auth-detail__domain-title">{{ 'AUTHENTICATION.DOMAIN' | translate }}</div>
    </div>

    <!-- Domain Table -->
    <table class="bz-table" *ngIf="showInputForNewDomain || domainList.length > 0">
      <thead>
        <tr>
          <th class="bz-table__cell bz-table__cell--sortable">
            {{ 'AUTHENTICATION.DOMAIN' | translate}}
          </th>
          <th class="bz-table__cell bz-table__cell--sortable">
            {{ 'AUTHENTICATION.DISPLAY_NAME' | translate}}
          </th>
          <th class="bz-table__cell bz-table__cell--sortable">
            {{'AUTHENTICATION.ACTIONS' | translate}}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Add new domain row -->
        <tr *ngIf="showInputForNewDomain">
          <td class="bz-table__cell">
            <bzg-input 
              id="domainValue" 
              [placeholder]="('AUTHENTICATION.TYPE_A_DOMAIN' | translate) + '...'" 
              [maxlength]="40" 
              [(ngModel)]="newDomainValue"
              (keydown)="onDomainKeydown($event)">
            </bzg-input>
          </td>
          <td class="bz-table__cell">
            <bzg-input 
              id="displayName" 
              [placeholder]="('AUTHENTICATION.TYPE_A_NAME' | translate) + '...'" 
              [maxlength]="40" 
              [(ngModel)]="newDomainDisplayName">
            </bzg-input>
          </td>
          <td class="bz-table__cell">
            <div class="multiple-auth-detail__table-actions">
              <bzg-button-icon 
                icon="icon-check-mark" 
                [filled]="true" 
                class="bz-space--inline-s"
                [disabled]="checkNecessaryFieldsForDomain() || isActiveMaintenance"
                (click)="onCheckDomainBeforeAdd()">
              </bzg-button-icon>
              <bzg-button-icon 
                icon="icon-delete" 
                [disabled]="isActiveMaintenance"
                (click)="onCancelDomain()">
              </bzg-button-icon>
            </div>
          </td>
        </tr>
        <!-- Existing domains -->
        <tr *ngFor="let domain of domainList">
          <td class="bz-table__cell">
            <label *ngIf="editModeDomain !== domain">{{ domain.name }}</label>
            <bzg-input 
              *ngIf="editModeDomain === domain" 
              [placeholder]="('AUTHENTICATION.TYPE_A_DOMAIN' | translate) + '...'" 
              [maxlength]="40" 
              [(ngModel)]="domain.name"
              (keydown)="onDomainKeydown($event)">
            </bzg-input>
          </td>
          <td class="bz-table__cell">
            <label *ngIf="editModeDomain !== domain">{{ domain.displayName }}</label>
            <bzg-input 
              *ngIf="editModeDomain === domain" 
              [placeholder]="('AUTHENTICATION.TYPE_A_NAME' | translate) + '...'" 
              [maxlength]="40" 
              [(ngModel)]="domain.displayName">
            </bzg-input>
          </td>
          <td class="bz-table__cell">
            <div class="multiple-auth-detail__table-actions">
              <bzg-button-icon 
                icon="icon-edit" 
                *ngIf="editModeDomain !== domain"
                class="bz-space--inline-s" 
                [disabled]="isActiveMaintenance"
                (click)="editModeDomain = domain">
              </bzg-button-icon>
              <bzg-button-icon 
                icon="icon-check-mark" 
                *ngIf="editModeDomain === domain" 
                [filled]="true" 
                class="bz-space--inline-s" 
                [disabled]="isActiveMaintenance"
                (click)="editModeDomain = null">
              </bzg-button-icon>
              <bzg-button-icon 
                icon="icon-delete" 
                [disabled]="isActiveMaintenance"
                (click)="deleteDomain(domain)">
              </bzg-button-icon>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <div class="multiple-auth-detail__buttons">
    <bzg-button-secondary (click)="onCancelNewAuthenticator()" [disabled]="isActiveMaintenance">
      {{ 'GLOBAL.CANCEL' | translate }}
    </bzg-button-secondary>
    <bzg-button-primary 
      (click)="onCreateNewAuthenticator()" 
      [disabled]="!isFormValid() || isActiveMaintenance">
      {{ "GLOBAL.SAVE" | translate }}
    </bzg-button-primary>
  </div>
</div>